module.exports = __webpack_public_path__ + "static/funding-circle-7cf663b7bc957fb6f573c94d5eb0599a.svg";